export default __webpack_public_path__ + "static/media/Icon=Manage.831ae3c7.svg";